import { RankingHeader, RankingRequest } from '@features/rankings/models/ranking.model'
import { PLACEHOLDER_IMAGES } from '@mediacoach/ui'
import { ComparableMetric, ListedMetric } from '@core/models/metric.models'
import { PlayerComparison } from '@core/models/player.models'
import { Aggregation } from '@features/aggregations/models/aggregations.models'

export const parsePlayerComparisonToRankingRequest = (
  context: PlayerComparison,
  value: ListedMetric | ComparableMetric,
  mode: Aggregation
): RankingRequest => ({
  seasonId: context?.playerA?.seasonId,
  competitionId: context?.playerA?.competitionId,
  metricName: value.key,
  players: [
    { playerId: context?.playerA.id, teamId: context?.playerA.teamId },
    { playerId: context?.playerB.id, teamId: context?.playerB.teamId }
  ],
  aggregationDataSource: mode
})

export const parsePlayerMatchComparisonToRankingRequest = (
  context: PlayerComparison,
  value: ListedMetric | ComparableMetric,
  mode: Aggregation
): RankingRequest => ({
  ...parsePlayerComparisonToRankingRequest(context, value, mode),
  matchId: context?.playerA?.matchId
})

export const parsePlayerComparisonRankingHeader = (
  metricKey: string,
  metricContext: PlayerComparison,
  matchDay: number
): RankingHeader => ({
  title: metricKey,
  imageA: metricContext?.playerA?.portraitLogo,
  textA: metricContext.playerA?.metricPlayerName,
  imageAStyleClass: 'mcm-rankings__avatar',
  imageB: metricContext?.playerB?.portraitLogo,
  textB: metricContext.playerB?.metricPlayerName,
  imageBStyleClass: 'mcm-rankings__avatar',
  placeholderA: PLACEHOLDER_IMAGES.PLAYER,
  placeholderB: PLACEHOLDER_IMAGES.PLAYER,
  matchDay
})
